<ng-template #filterFacets>
  <ng-container *ngIf="locationFacet && locationFacet.length > 0 && showlocation == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Location" | translate }}
    </h5>
    <ul class="list-group" *ngIf="locationFacetLessShow">
      <li role="button"
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of locationFacetLess" (click)="addFilter('LOCATION', s.name)">
        <!-- {{s.name}} -->

        <app-location-name [LOCATIONID]="s.name"></app-location-name>
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="locationFacetLess.length >= facetLess"
                (click)="MoreLocation(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="locationFacetLess.length >=facetLess "
          (click)="openMoreFilterDialog('LOCATION','Location', locationFacet)">{{ 'More' | translate }}...</a>

      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="locationFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of locationFacet" (click)="addFilter('LOCATION', s.name)">
        <!-- {{s.name}} -->

        <app-location-name [LOCATIONID]="s.name"></app-location-name>
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai">
        <a class="a-walai text-primary" (click)="MoreLocation(true)">...{{ 'Less' | translate }}</a>
      </li>
    </ul>
  </ng-container>

  <!-- subjectFacet -->
  <ng-container *ngIf="subjectFacet && subjectFacet.length > 0 && showSubject == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Subject" | translate }}
    </h5>
    <ul class="list-group" *ngIf="subjectFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of subjectFacetLess" (click)="addFilter('SUBJECTFACET', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>

      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="subjectFacetLess.length >= facetLess"
                (click)="MoreSubject(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="subjectFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('SUBJECTFACET','Subject', subjectFacet)">{{ 'More' | translate }}...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="subjectFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of subjectFacet" (click)="addFilter('SUBJECTFACET', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai">
        <a class="a-walai text-primary" (click)="MoreSubject(true)">...{{ 'Less' | translate }}</a>
      </li>
    </ul>
  </ng-container>

  <!-- authorFacet -->
  <ng-container *ngIf="authorFacet && authorFacet.length > 0 && showAuthor == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Author" | translate }}
    </h5>
    <ul class="list-group" *ngIf="authorFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of authorFacetLess" (click)="addFilter('AUTHORFACET', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="authorFacetLess.length >= facetLess"
                (click)="MoreAuthor(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="authorFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('AUTHORFACET','Author', authorFacet)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="authorFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of authorFacet" (click)="addFilter('AUTHORFACET', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreAuthor(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Pubyear -->
  <ng-container *ngIf="bookcount && showPubyear == 1">
    <h5 class="list-group-item facet-heading">
      {{ "PublishYear" | translate }}
    </h5>
    <div class="px-3 pb-3 me-2">

      <mat-slider class="w-100 mb-2 me-2" [min]="year_min" [max]="year_max" showTickMarks discrete color="primary">
        <input [(ngModel)]="year_Cmin_value" matSliderStartThumb>
        <input [(ngModel)]="year_Cmax_value" matSliderEndThumb>
      </mat-slider>

      <div class="row g-2 mb-3">
        <div class="col-6">
          <input type="number" class="form-control form-control-sm rounded-3 bg-light border-1"
            placeholder="{{ 'From' | translate }}" [(ngModel)]="year_Cmin_value" />
        </div>
        <div class="col-6">
          <input type="number" class="form-control form-control-sm rounded-3 bg-light border-1"
            placeholder="{{ 'ToYear' | translate }}" [(ngModel)]="year_Cmax_value" />
        </div>
      </div>

      <div class="d-grid">
        <button (click)="addFilterYear()" type="button"
          class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none">
          {{ "Filter" | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <!-- sourceTypeFacet -->
  <ng-container *ngIf="sourceTypeFacet && sourceTypeFacet.length > 0 && showMattype == 1">
    <h5 class="list-group-item facet-heading">
      {{ "SourceType" | translate }}
    </h5>
    <ul class="list-group" *ngIf="sourceTypeFacet">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of sourceTypeFacet" (click)="addFilter('MEDIATYPE', s.name)">
        {{ getMEDIATYPENameByID(s.name) }}
        <!-- <app-location-name [LOCATIONID]="s.name"></app-location-name> -->
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai"></li>
    </ul>
  </ng-container>

  <!-- collection -->
  <ng-container *ngIf="collectionFacet && collectionFacet.length > 0 && showCollection == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Collection" | translate }}
    </h5>
    <ul class="list-group" *ngIf="collectionFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of collectionFacetLess" (click)="addFilter('collection', s.name)">
        {{ getCollectionDisplayName(s.name) }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="collectionFacetLess.length >= facetLess"
                (click)="Morecollection(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="collectionFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('collection','collection', collectionFacet)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="collectionFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of collectionFacet" (click)="addFilter('collection', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="Morecollection(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- lang -->
  <ng-container *ngIf="langFacet && langFacet.length > 0 && showLang == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Language" | translate }}
    </h5>
    <ul class="list-group" *ngIf="langFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of langFacetLess" (click)="addFilter('lang', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="langFacetLess.length >= facetLess"
                (click)="Morelang(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="langFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('lang','lang', langFacet)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="langFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of langFacet" (click)="addFilter('lang', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="Morelang(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Region -->
  <ng-container *ngIf="RegionFacet.length && showRegion == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Geographic Area" | translate }}
    </h5>
    <ul class="list-group" *ngIf="RegionFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of RegionFacetLess" (click)="addFilter('Region', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="RegionFacetLess.length >= facetLess"
          (click)="MoreRegion(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="RegionFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of RegionFacet" (click)="addFilter('Region', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreRegion(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Era -->
  <ng-container *ngIf="EraFacet.length && showEra == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Era" | translate }}
    </h5>
    <ul class="list-group" *ngIf="EraFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of EraFacetLess" (click)="addFilter('Era', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="EraFacetLess.length >= facetLess" (click)="MoreEra(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="EraFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of EraFacet" (click)="addFilter('Era', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreEra(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- CallNoLC -->
  <ng-container *ngIf="CallNoLCFacet && CallNoLCFacet.length > 0 && showCallNoLC == 1">
    <h5 class="list-group-item facet-heading">
      {{ "LC Call Number" | translate }}
    </h5>
    <ul class="list-group" *ngIf="CallNoLCFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoLCFacetLess" (click)="addFilter('CallNoLC', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="CallNoLCFacetLess.length >= facetLess"
                (click)="MoreCallNoLC(false)"
                >more...</a
              > -->
        <a class="a-walai text-primary" *ngIf="CallNoLCFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('Call no LC','CallNoLC', CallNoLCFacet)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="CallNoLCFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoLCFacet" (click)="addFilter('CallNoLC', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreCallNoLC(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- CallNoDC -->
  <ng-container *ngIf="CallNoDCFacet && CallNoDCFacet.length > 0 && showCallNoDC == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Dewey Call Number" | translate }}
    </h5>
    <ul class="list-group" *ngIf="CallNoDCFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoDCFacetLess" (click)="addFilter('CallNoDC', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="CallNoDCFacetLess.length >= facetLess"
                (click)="MoreCallNoDC(false)"
                >more...</a
              > -->

        <a class="a-walai text-primary" *ngIf="CallNoDCFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('Call no DC','CallNoDC', CallNoDCFacet)">more...</a>

      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="CallNoDCFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoDCFacet" (click)="addFilter('CallNoDC', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreCallNoDC(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- CallNoNLM -->
  <ng-container *ngIf="CallNoNLMFacet && CallNoNLMFacet.length > 0 && showCallNoNLM == 1">
    <h5 class="list-group-item facet-heading">
      {{ "NLM Call Number" | translate }}
    </h5>
    <ul class="list-group" *ngIf="CallNoNLMFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoNLMFacetLess" (click)="addFilter('CallNoNLM', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <!-- <a
                class="a-walai text-primary"
                *ngIf="CallNoNLMFacetLess.length >= facetLess"
                (click)="MoreCallNoNLM(false)"
                >more...</a
              > -->

        <a class="a-walai text-primary" *ngIf="CallNoNLMFacetLess.length >= facetLess"
          (click)="openMoreFilterDialog('Call no NLM','CallNoNLM', CallNoNLMFacet)">more...</a>

      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="CallNoNLMFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of CallNoNLMFacet" (click)="addFilter('CallNoNLM', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreCallNoNLM(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Illustrations -->
  <ng-container *ngIf="IllustrationsFacet && IllustrationsFacet.length > 0 && showIllustrations == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Illustrations" | translate }}
    </h5>
    <ul class="list-group" *ngIf="IllustrationsFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of IllustrationsFacetLess" (click)="addFilter('Illustrations', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="IllustrationsFacetLess.length >= facetLess"
          (click)="MoreIllustrations(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="IllustrationsFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of IllustrationsFacet" (click)="addFilter('Illustrations', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreIllustrations(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- TargetAudience -->
  <ng-container *ngIf="TargetAudienceFacet && TargetAudienceFacet.length > 0 && showTargetAudience == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Target Audience" | translate }}
    </h5>
    <ul class="list-group" *ngIf="TargetAudienceFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of TargetAudienceFacetLess" (click)="addFilter('TargetAudience', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="TargetAudienceFacetLess.length >= facetLess"
          (click)="MoreTargetAudience(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="TargetAudienceFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of TargetAudienceFacet" (click)="addFilter('TargetAudience', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreTargetAudience(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- FormofItem -->
  <ng-container *ngIf="FormofItemFacet && FormofItemFacet.length > 0 && showFormofItem == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Form of Item" | translate }}
    </h5>
    <ul class="list-group" *ngIf="FormofItemFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of FormofItemFacetLess" (click)="addFilter('FormofItem', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="FormofItemFacetLess.length >= facetLess"
          (click)="MoreFormofItem(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="FormofItemFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of FormofItemFacet" (click)="addFilter('FormofItem', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreFormofItem(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- NatureOfContents -->
  <ng-container *ngIf="NatureOfContentsFacet && NatureOfContentsFacet.length > 0 && showNatureOfContents == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Nature of Contents" | translate }}
    </h5>
    <ul class="list-group" *ngIf="NatureOfContentsFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of NatureOfContentsFacetLess" (click)="addFilter('NatureOfContents', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="NatureOfContentsFacetLess.length >= facetLess"
          (click)="MoreNatureOfContents(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="NatureOfContentsFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of NatureOfContentsFacet" (click)="addFilter('NatureOfContents', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreNatureOfContents(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- GovernmentPublication -->
  <ng-container
    *ngIf="GovernmentPublicationFacet && GovernmentPublicationFacet.length > 0 && showGovernmentPublication == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Government Publication" | translate }}
    </h5>
    <ul class="list-group" *ngIf="GovernmentPublicationFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of GovernmentPublicationFacetLess" (click)="addFilter('GovernmentPublication', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="GovernmentPublicationFacetLess.length >= facetLess"
          (click)="MoreGovernmentPublication(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="GovernmentPublicationFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of GovernmentPublicationFacet" (click)="addFilter('GovernmentPublication', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreGovernmentPublication(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- ConferencePublication -->
  <ng-container
    *ngIf="ConferencePublicationFacet && ConferencePublicationFacet.length > 0 && showConferencePublication == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Conference Publication" | translate }}
    </h5>
    <ul class="list-group" *ngIf="ConferencePublicationFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of ConferencePublicationFacetLess" (click)="addFilter('ConferencePublication', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="ConferencePublicationFacetLess.length >= facetLess"
          (click)="MoreConferencePublication(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="ConferencePublicationFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of ConferencePublicationFacet" (click)="addFilter('ConferencePublication', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreConferencePublication(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Festschrift -->
  <ng-container *ngIf="FestschriftFacet && FestschriftFacet.length > 0 && showFestschrift == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Festschrift" | translate }}
    </h5>
    <ul class="list-group" *ngIf="FestschriftFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of FestschriftFacetLess" (click)="addFilter('Festschrift', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="FestschriftFacetLess.length >= facetLess"
          (click)="MoreFestschrift(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="FestschriftFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of FestschriftFacet" (click)="addFilter('Festschrift', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreFestschrift(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- LiteraryForm -->
  <ng-container *ngIf="LiteraryFormFacet && LiteraryFormFacet.length > 0 && showLiteraryForm == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Literary Form" | translate }}
    </h5>
    <ul class="list-group" *ngIf="LiteraryFormFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of LiteraryFormFacetLess" (click)="addFilter('LiteraryForm', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="LiteraryFormFacetLess.length >= facetLess"
          (click)="MoreLiteraryForm(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="LiteraryFormFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of LiteraryFormFacet" (click)="addFilter('LiteraryForm', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreLiteraryForm(true)">...less</a>
      </li>
    </ul>
  </ng-container>

  <!-- Biography -->
  <ng-container *ngIf="BiographyFacet && BiographyFacet.length > 0 && showBiography == 1">
    <h5 class="list-group-item facet-heading">
      {{ "Biography" | translate }}
    </h5>
    <ul class="list-group" *ngIf="BiographyFacetLessShow">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of BiographyFacetLess" (click)="addFilter('Biography', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" *ngIf="BiographyFacetLess.length >= facetLess"
          (click)="MoreBiography(false)">more...</a>
      </li>
    </ul>

    <!-- When Show More -->
    <ul class="list-group" *ngIf="BiographyFacetLessShow == false">
      <li
        class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai text-walai-default-color a-walai"
        *ngFor="let s of BiographyFacet" (click)="addFilter('Biography', s.name)">
        {{ s.name }}
        <span class="badge bg-secondary text-dark fw-normal">{{
          s.count
          }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-walai a-walai">
        <a class="a-walai text-primary" (click)="MoreBiography(true)">...less</a>
      </li>
    </ul>
  </ng-container>
</ng-template>
<!-- banner and search bar -->
<div class="jumbotron" [ngStyle]="imgBannerUrl">
  <div class="container-fluid py-4 py-lg-5">
    <div class="d-flex justify-content-center py-lg-5">
      <div class="col-12 col-lg-8 col-xl-6">
        <div class="input-group Bg-Search" [formGroup]="qsearchForm">

          <div>
            <button id="inputState" class="btn rounded-0 border-0 btn-search-type" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-filter-circle me-1  "></i>
              <span class="mx-1">{{ inputState | translate }}</span>
              <i class="bi bi-chevron-down ms-1"></i>
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" role="button" (click)="SearchOption('KEYWORD', 'Keyword')">{{ 'Keyword' |
                  translate }}</a></li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('TITLE', 'Title')">{{ 'Title' | translate
                  }}</a></li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('AUTHOR', 'Author')">{{ 'Author' |
                  translate }}</a></li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('SUBJECT', 'Subject')">{{ 'Subject' |
                  translate }}</a></li>

              <li><a class="dropdown-item" role="button" (click)="SearchOption('PUBLISHER', 'Publisher')">{{ 'Publisher'
                  |
                  translate }}</a>
              </li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('JOURNALTITLE', 'Journal')">{{ 'Journal'
                  |
                  translate }}</a>
              </li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('CALLNUMBER', 'Call number')">{{ 'Call
                  number' | translate }}</a></li>
              <li><a class="dropdown-item" role="button" (click)="SearchOption('ISBNISSN', 'ISBN/ISSN')">{{ 'ISBN/ISSN'
                  |
                  translate }}</a>
              </li>

            </ul>
          </div>


          <input type="text" class="form-control border-start" placeholder="{{ 'SearchPlaceholder' | translate }}"
            formControlName="textSearch" (keydown.enter)="search(true,'')" id="txtSearch" />

          <div class="input-group-append">
            <button type="button" class="color-orange1 btn" id="btnSearch" (click)="search(true,'')">
              <i class="bi bi-search" width="24" height="24" viewBox="0 0 24 24"></i>
            </button>
          </div>

        </div>
        <!-- Refined Search Switch -->
        <div class="d-flex justify-content-end mt-2 px-3">
          <div class="form-check form-switch d-flex align-items-center gap-2 mb-0" style="min-height: auto;">
            <input class="form-check-input shadow-sm m-0" style="cursor: pointer; width: 2.5em; height: 1.25em;"
              type="checkbox" role="switch" id="isRefindedSearch" [(ngModel)]="isRefindedSearch">
            <label class="form-check-label small fw-bold text-white shadow-sm text-uppercase"
              style="letter-spacing: 0.05em; cursor: pointer;" for="isRefindedSearch">
              {{ 'Refined Search' | translate }}
            </label>
          </div>
        </div>
        <!-- Authority Suggestions -->
        <div class="mt-4 text-center d-flex flex-column align-items-center w-100" *ngIf="auth.length > 0">
          <div class="d-flex flex-wrap justify-content-center gap-2">
            <button type="button" class="term-chip chip-bt border-0 shadow-sm" *ngIf="BT"
              (click)="showAuth(BT.authid, 'BT')">
              <i class="bi bi-diagram-3"></i>
              {{ 'Broader Term' | translate }} <span class="badge">{{ BT.Count }}</span>
            </button>

            <button type="button" class="term-chip chip-nt border-0 shadow-sm" *ngIf="NT"
              (click)="showAuth(NT.authid, 'NT')">
              <i class="bi bi-diagram-2"></i>
              {{ 'Narrower Term' | translate }} <span class="badge">{{ NT.Count }}</span>
            </button>

            <button type="button" class="term-chip chip-rt border-0 shadow-sm" *ngIf="RT"
              (click)="showAuth(RT.authid, 'RT')">
              <i class="bi bi-arrow-left-right"></i>
              {{ 'Related Term' | translate }} <span class="badge">{{ RT.Count }}</span>
            </button>

            <button type="button" class="term-chip chip-lv border-0 shadow-sm" *ngIf="LV"
              (click)="showAuth(LV.authid, 'LV')">
              <i class="bi bi-translate"></i>
              {{ 'Language Variants' | translate }}
              <span class="badge">{{ LV.Count }}</span>
            </button>
          </div>
          <div class="authority-suggestions-glass d-flex align-items-center flex-wrap gap-2 mt-3"
            *ngIf="AuthSymbol.length > 0">
            <span class="badge-authority-suggestion rounded-pill shadow-sm pointer"
              (click)="searchAuth(item.REFID, item.AUTHVIEWOPAC)" *ngFor="let item of AuthSymbol">
              <i class="bi bi-lightbulb me-1 opacity-75"></i> {{ item.AUTHVIEWOPAC }}
            </span>

            <button type="button" class="btn-close ms-auto" (click)="AuthSymbol = []" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- search results -->
<div class="container-lg pt-5 pb-3">
  <!-- Search Results Current Keyword & Filters -->
  <div class="col-12 mb-4 d-flex align-items-center flex-wrap gap-2">
    <span class="text-uppercase text-secondary fw-bold small me-2" style="letter-spacing: 0.05em;">
      <i class="bi bi-search me-1"></i> {{ "SearchResults" | translate }}:
    </span>

    <!-- Keywords -->
    <a href="javascript:void(0);"
      class="badge-keyword rounded-pill shadow-sm px-3 py-1 d-flex align-items-center text-decoration-none"
      (click)="RemoveKeyword(item.Ntk, item.id || item.Ntt)" *ngFor="let item of CurrentKeyword; let i = index">
      <span class="opacity-75 fw-normal me-1">{{ item.Ntk }}:</span>
      <span class="fw-semibold">{{ ConvertCurrentFilterAndKeywordToText(item) }}</span>
      <i class="bi bi-x-lg ms-2" style="font-size: 0.8rem;"></i>
    </a>

    <!-- Active Filters -->
    <ng-container *ngIf="CurrentFilter.length > 0">
      <a href="javascript:void(0);"
        class="badge-filter rounded-pill shadow-sm px-3 py-1 d-flex align-items-center text-decoration-none"
        (click)="RemoveKeyword(filter.Ntk, filter.id)" *ngFor="let filter of CurrentFilter">
        <span class="opacity-75 fw-normal me-1 small">{{ getFilterLabel(filter.Ntk) | translate
          }}:</span>
        <span class="fw-semibold">{{ filter.Ntt }}</span>
        <i class="bi bi-x-lg ms-2" style="font-size: 0.8rem;"></i>
      </a>
    </ng-container>
  </div>

  <!-- *ngIf="bookcount!=null" -->
  <div class="row gx-xl-5 p-0">
    <ng-template #sidebarLayout>
      <div class="results-sidebar-card bg-white border rounded-4 shadow-sm p-4 h-100">
        <div class="mb-4">
          <h5 class="mb-0 fw-bold text-dark d-flex align-items-center">
            <i class="bi bi-sliders me-2 text-primary"></i> {{ "Filter" | translate }}
          </h5>
        </div>


        <div *ngIf="bookcount != null" class="list-group list-group-flush facet-list-modern">
          <!-- locationFacet -->
          <ng-container *ngTemplateOutlet="filterFacets"></ng-container>
        </div>
      </div>
    </ng-template>

    <!-- Sidebar -->
    <aside class="col-12 col-xl-3 d-none d-xl-block mb-4" *ngIf="bookcount != null">
      <div class="py-2">
        <ng-container *ngTemplateOutlet="sidebarLayout"></ng-container>
      </div>
    </aside>

    <!-- aside responsive-->
    <div class="offcanvas offcanvas-start d-xl-none" tabindex="-1" id="offcanvasFilter"
      aria-labelledby="offcanvasFilterLabel">
      <div class="offcanvas-header justify-content-end">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <!-- offcanvas-body -->
      <div class="offcanvas-body">
        <ng-container *ngTemplateOutlet="sidebarLayout"></ng-container>
      </div>
    </div>

    <!-- Main Content -->
    <main [class]="bookcount != null ? 'col-12 col-xl-9' : 'col-12'">
      <!-- Modern Results Header -->
      <div class="py-2 mb-3" style="background: transparent;" *ngIf="bookcount != null">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-md-center px-4 py-3 bg-white border rounded-4 shadow-sm results-header-floating">

          <!-- Result Count -->
          <div class="mb-3 mb-md-0">
            <h5 *ngIf="bookcount == '...'" class="mb-0 fw-bold text-secondary d-flex align-items-center">
              <div class="spinner-border spinner-border-sm me-2" role="status"></div>
              {{ 'Loading' | translate }}
            </h5>
            <h5 *ngIf="bookcount != null && bookcount != '...'" class="mb-0 fw-bold text-dark">
              <span class="text-secondary fw-normal fs-6">
                {{ 'Showing' | translate }}
                <span class="text-primary fw-bold">{{ (keyword.CurrentPage - 1) * keyword.RowPerPage + 1 | number
                  }}</span>
                {{ 'to' | translate }}
                <span class="text-primary fw-bold">{{ (keyword.CurrentPage * keyword.RowPerPage < recordCount ?
                    keyword.CurrentPage * keyword.RowPerPage : recordCount) | number }}</span>
                    {{ 'Of' | translate }}
                    <span class="text-primary fw-bold">{{ recordCount | number }}</span>
                    {{ 'Results' | translate }}
                </span>
            </h5>
            <h5 *ngIf="bookcount == null" class="mb-0 fw-bold text-muted opacity-50">
              <i class="bi bi-search me-1"></i> {{ "SearchResults" | translate }}
            </h5>
          </div>

          <!-- Toolbar (Sort & View) -->
          <div class="d-flex align-items-center app-toolbar gap-3">

            <!-- Mobile Filter Toggle -->
            <button
              class="btn btn-outline-secondary d-xl-none rounded-pill px-3 btn-sm d-flex align-items-center text-nowrap"
              type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasFilter"
              aria-controls="offcanvasFilter">
              <i class="bi bi-funnel me-1"></i> {{ 'Filter' | translate }}
            </button>

            <!-- Sort Select -->
            <div class="d-flex align-items-center">
              <i class="bi bi-sort-down text-muted me-2"></i>
              <select id="inputState"
                class="form-select form-select-sm border-0 bg-light rounded-pill px-3 fw-bold text-secondary"
                style="min-width: 140px;" (change)="changeOrderBy($event)">
                <option value="RELEVANCE" selected>{{ 'RELEVANCE' | translate }}</option>
                <option value="TITLE">{{ 'TITLE_ASC' | translate }}</option>
                <option value="PUBYEAR DESC">{{ 'NEWEST_FIRST' | translate }}</option>
                <option value="PUBYEAR ASC">{{ 'OLDEST_FIRST' | translate }}</option>
                <option value="AUTHOR">{{ 'AUTHOR_ASC' | translate }}</option>
                <option value="CALLNUMBER">{{ 'CALLNUMBER_SORT' | translate }}</option>
              </select>
            </div>

            <!-- Divider -->
            <!-- <div class="vr h-100 mx-1 text-muted opacity-25"></div> -->

            <!-- View Toggle -->
            <div class="d-flex gap-2" role="group" aria-label="View toggle">
              <button type="button"
                [ngClass]="_DisplayStyle === 'Table' ? 'btnDisplayStyle-active btn btn-sm rounded-3 px-3 shadow-sm' : 'btnDisplayStyle btn btn-sm rounded-3 px-3'"
                (click)="DisplayStyle('Table')">
                <i class="bi bi-grid-fill fs-6"></i>
              </button>
              <button type="button"
                [ngClass]="_DisplayStyle === 'List' ? 'btnDisplayStyle-active btn btn-sm rounded-3 px-3 shadow-sm' : 'btnDisplayStyle btn btn-sm rounded-3 px-3'"
                (click)="DisplayStyle('List')">
                <i class="bi bi-list-ul fs-5"></i>
              </button>
            </div>

          </div>
        </div>
      </div>

      <!-- content -->
      <div class="px-3 px-lg-4 position-relative">
        <!-- Removed duplicate filter button from here -->

        <!-- <mat-paginator *ngIf="recordCount>Size" class="bg-light" aria-label="Select page" [pageSize]="Size"
          [pageIndex]="keyword.CurrentPage - 1" (page)="pageNavigations($event)" [length]="recordCount">
        </mat-paginator> -->


        <div *ngIf="bookcount != null ">
          <!-- <div class="search-results mt-5" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()"> -->
          <div class="search-results mt-5">
            <div class="search-results">
              <ul class="list-unstyled" *ngIf="_DisplayStyle == 'List'">
                <li class="mb-4" *ngFor="let b of bookList">
                  <div class="card border rounded-3 shadow-sm overflow-hidden h-100 bg-white">
                    <div class="row g-0">
                      <!-- Cover Section -->
                      <div
                        class="col-md-4 col-xl-3 bg-light d-flex align-items-center justify-content-center p-3 border-end-md">
                        <div class="DivBookCover DivBookCover-list h-100">
                          <a [href]="'bibitem?bibid=' + b.id" class="text-decoration-none h-100 d-block">
                            <app-book-cover-share [bookCoverURL]="b.bookcover" [id]="b.id" [cssStyle]="'w-100 h-100'"
                              [title]="b.Title"></app-book-cover-share>
                          </a>
                        </div>
                      </div>

                      <!-- Details Section -->
                      <div class="col-md-8 col-xl-9">
                        <div class="card-body p-3 p-lg-4 d-flex flex-column h-100">
                          <!-- Title -->
                          <h5 class="mb-3">
                            <a class="text-decoration-none text-dark fw-bold a-walai-book" target="_blank"
                              href="bibitem?bibid={{ b.id }}" style="font-size: 1.15rem; line-height: 1.4;">
                              {{ removeSlash(b.Title) }}
                            </a>
                          </h5>

                          <!-- Meta Data -->
                          <div class="flex-grow-1 small text-dark">
                            <div class="row mb-1" *ngIf="b.Author">
                              <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Author" | translate }}</div>
                              <div class="col-9 col-lg-10">{{ b.Author }}</div>
                            </div>
                            <div class="row mb-1" *ngIf="b.Publisher">
                              <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Published" | translate }}</div>
                              <div class="col-9 col-lg-10">{{ b.Publisher }}</div>
                            </div>
                            <div class="row mb-1" *ngIf="b.CALLNUMBER">
                              <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Callnumber" | translate }}
                              </div>
                              <div class="col-9 col-lg-10"><span class="badge bg-light text-dark border">{{
                                  b.CALLNUMBER
                                  }}</span></div>
                            </div>
                            <div class="row mb-1" *ngIf="b.source">
                              <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Source" | translate }}</div>
                              <div class="col-9 col-lg-10">{{ b.source }}</div>
                            </div>
                            <div class="row mb-1" *ngIf="b.LOCATION">
                              <div class="col-3 col-lg-2 text-secondary fw-medium">{{ "Location" | translate }}</div>
                              <div class="col-9 col-lg-10">{{ b.LOCATION }}</div>
                            </div>
                          </div>

                          <!-- Actions Bar -->
                          <div class="mt-3 pt-3 border-top d-flex flex-wrap align-items-center gap-3">
                            <app-electronic-resource [bibid]="b.id"></app-electronic-resource>

                            <div class="ms-auto">
                              <button type="button"
                                class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none gap-2"
                                (click)="save(b.id)" title="{{'Save for export'| translate}}">
                                <i class="bi bi-bookmark-plus me-2"></i>
                                <span>{{'Save' | translate}}</span>
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <div *ngIf="_DisplayStyle == 'Table'" class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-4">
                <div class="col" *ngFor="let b of bookList">
                  <div id="book-card-{{b.id}}" class="h-100 pb-3">
                    <div class="DivBookCover position-relative">
                      <a [href]="'bibitem?bibid=' + b.id" target="_blank"
                        class="text-decoration-none h-100 d-block bookcover-card">
                        <app-book-cover-share [bookCoverURL]="b.bookcover" [id]="b.id"
                          [cssStyle]="'img-fluid w-100 h-100 bookcover-card'" [title]="b.Title | shortTitle : 35">
                        </app-book-cover-share>
                      </a>
                      <div class="position-absolute top-0 end-0 z-3 m-2">
                        <button type="button"
                          class="btn border-0 rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0 btn-save-action"
                          style="width: 36px; height: 36px; background: rgba(255,255,255,0.98); backdrop-filter: blur(8px); transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);"
                          (click)="$event.preventDefault(); $event.stopPropagation(); save(b.id)"
                          (mouseenter)="$event.target.style.transform='scale(1.1)'; $event.target.style.boxShadow='0 4px 12px rgba(0,0,0,0.15)'"
                          (mouseleave)="$event.target.style.transform='scale(1)'; $event.target.style.boxShadow='0 1px 3px rgba(0,0,0,0.12)'"
                          title="{{'Save' | translate}}">
                          <i class="bi bi-bookmark-plus fs-5" style="transition: all 0.2s ease;"></i>
                        </button>
                      </div>
                    </div>
                    <a class="a-walai-book-card-view text-center px-2" [href]="'bibitem?bibid=' + b.id" target="_blank"
                      [title]="removeSlash(b.Title)">
                      {{ removeSlash(b.Title) }}
                    </a>
                    <span class="author-text-card-view text-center" [title]="b.Author">
                      {{ b.Author }}
                    </span>
                    <div class="text-center mt-2">
                      <app-electronic-resource [bibid]="b.id" [DisplayStyle]="_DisplayStyle"></app-electronic-resource>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div *ngIf="recordCount>Size" class="d-flex justify-content-center my-5">
              <!-- Custom Beautiful Paginator -->
              <nav aria-label="Page navigation" class="custom-paginator">
                <ul class="pagination pagination-modern mb-0 gap-2">
                  <!-- Previous Button -->
                  <li class="page-item" [class.disabled]="keyword.CurrentPage === 1">
                    <a class="page-link page-link-arrow"
                      (click)="keyword.CurrentPage > 1 && PageEventChange(keyword.CurrentPage - 1)"
                      [class.disabled]="keyword.CurrentPage === 1" aria-label="Previous">
                      <i class="bi bi-chevron-left"></i>
                    </a>
                  </li>

                  <!-- First Page -->
                  <li class="page-item" *ngIf="getPageNumbers().length > 0 && getPageNumbers()[0] > 1">
                    <a class="page-link page-link-circle" (click)="PageEventChange(1)"
                      [class.active]="keyword.CurrentPage === 1">
                      1
                    </a>
                  </li>

                  <!-- Ellipsis Before -->
                  <li class="page-item disabled" *ngIf="getPageNumbers().length > 0 && getPageNumbers()[0] > 2">
                    <span class="page-link page-link-ellipsis">...</span>
                  </li>

                  <!-- Page Numbers -->
                  <li class="page-item" *ngFor="let page of getPageNumbers()">
                    <a class="page-link page-link-circle" (click)="PageEventChange(page)"
                      [class.active]="keyword.CurrentPage === page">
                      {{ page }}
                    </a>
                  </li>

                  <!-- Ellipsis After -->
                  <li class="page-item disabled"
                    *ngIf="getPageNumbers().length > 0 && getPageNumbers()[getPageNumbers().length - 1] < getTotalPages() - 1">
                    <span class="page-link page-link-ellipsis">...</span>
                  </li>

                  <!-- Last Page -->
                  <li class="page-item"
                    *ngIf="getPageNumbers().length > 0 && getPageNumbers()[getPageNumbers().length - 1] < getTotalPages()">
                    <a class="page-link page-link-circle" (click)="PageEventChange(getTotalPages())"
                      [class.active]="keyword.CurrentPage === getTotalPages()">
                      {{ getTotalPages() }}
                    </a>
                  </li>

                  <!-- Next Button -->
                  <li class="page-item" [class.disabled]="keyword.CurrentPage === getTotalPages()">
                    <a class="page-link page-link-arrow"
                      (click)="keyword.CurrentPage < getTotalPages() && PageEventChange(keyword.CurrentPage + 1)"
                      [class.disabled]="keyword.CurrentPage === getTotalPages()" aria-label="Next">
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

          </div>

          <!-- spinner -->
          <!-- <div class="row pb-5">
            <div class="col-md-12 p-5">
              <ngx-spinner
                bdOpacity="0.9"
                bdColor=""
                size="default"
                color="#581f87"
                type="ball-pulse-sync"
                [fullScreen]="false"
              >
              </ngx-spinner>
            </div>
          </div> -->

          <!-- Alert no more post -->
          <!-- <div *ngIf="!notEmptyPost" class="row pb-5">
            <div class="col-md-12 d-flex justify-content-center">
              <div class="text-muted alert p-2" style="font-weight: lighter">
                {{ "No more resource to show" | translate }}
              </div>
            </div>
          </div> -->
        </div>

        <!-- *ngIf=" suggesterWord.length>0 && (recordCount<1 ||recordCount>15)" -->


        <!-- Beautiful No Results (Empty State) -->
        <div *ngIf="bookcount == null" class="empty-state-container mt-0 text-center">
          <div class="empty-state-icon mb-4">
            <div class="icon-glow"></div>
            <i class="bi bi-search text-primary opacity-25" style="font-size: 5rem;"></i>
          </div>
          <h2 class="fw-bold text-dark mb-3">{{ "NoResultsTitle" | translate }}</h2>
          <p class="text-secondary mb-4 mx-auto" style="max-width: 500px;">
            {{ "NoResultsDetail" | translate }}
          </p>

          <div class="suggestions-card bg-light rounded-4 p-4 mb-4 mx-auto text-start border border-white shadow-sm"
            style="max-width: 500px;">
            <h6 class="fw-bold text-dark mb-3">
              <i class="bi bi-lightbulb text-warning me-2"></i> {{ "SuggestionTitle" | translate }}
            </h6>
            <ul class="list-unstyled mb-0 small text-secondary">
              <li class="mb-2 d-flex align-items-start">
                <i class="bi bi-check2-circle text-success me-2 mt-1"></i>
                {{ "CheckSpelling" | translate }}
              </li>
              <li class="mb-2 d-flex align-items-start">
                <i class="bi bi-check2-circle text-success me-2 mt-1"></i>
                {{ "BroaderTerms" | translate }}
              </li>
              <li class="d-flex align-items-start">
                <i class="bi bi-check2-circle text-success me-2 mt-1"></i>
                {{ "RemoveFilters" | translate }}
              </li>
            </ul>
          </div>

          <button (click)="resetSearch()"
            class="btn btn-primary rounded-pill px-4 py-2 shadow-sm gap-2 d-inline-flex align-items-center transition-all hover-scale">
            <i class="bi bi-arrow-counterclockwise fs-5"></i>
            <span class="fw-bold">{{ "ResetSearch" | translate }}</span>
          </button>

          <!-- <div class="mt-4">
            <button type="button"
              class="btn btn-link link-secondary  text-decoration-none small d-inline-flex align-items-center gap-1 opacity-75 hover-opacity-100"
              data-bs-toggle="modal" data-bs-target="#searchGuideModal">
              <i class="bi bi-info-circle"></i>
              {{ "SearchGuide" | translate }}
            </button>
          </div> -->
        </div>

        <div class="card w-100 border-0 mt-4" *ngIf=" suggesterWord.length>0 && (recordCount<1 ||recordCount>15)">
          <div class="card-body">
            <h5 class="card-title fw-bold text-dark border-start border-primary border-4 ps-3 mb-3">{{ 'DidYouMean' |
              translate }} </h5>
            <div class="d-flex flex-wrap gap-2">
              <span *ngFor="let item of suggesterWord"
                class="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 fw-medium pointer transition-all hover-shadow"
                (click)="search(false,item)">
                <i class="bi bi-magic me-1"></i> {{item}}
              </span>
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</div>

<!-- Search Guide Modal -->
<div class="modal fade" id="searchGuideModal" tabindex="-1" aria-labelledby="searchGuideModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
      <div class="modal-header border-0 bg-light p-4">
        <h5 class="modal-title fw-bold d-flex align-items-center gap-2" id="searchGuideModalLabel">
          <i class="bi bi-book text-primary"></i> {{ "SearchPrinciples" | translate }}
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-4 p-md-5">
        <div class="row g-4">
          <!-- Wildcards -->
          <div class="col-md-6">
            <div class="guide-item d-flex gap-3">
              <div class="icon-box bg-primary-subtle rounded-3 p-2 h-fit">
                <i class="bi bi-asterisk text-primary fs-4"></i>
              </div>
              <div>
                <h6 class="fw-bold mb-2">{{ "WildcardTitle" | translate }}</h6>
                <p class="small text-secondary mb-0">{{ "WildcardDetail" | translate }}</p>
              </div>
            </div>
          </div>
          <!-- Exact Phrase -->
          <div class="col-md-6">
            <div class="guide-item d-flex gap-3">
              <div class="icon-box bg-success-subtle rounded-3 p-2 h-fit">
                <i class="bi bi-quote text-success fs-4"></i>
              </div>
              <div>
                <h6 class="fw-bold mb-2">{{ "PhraseTitle" | translate }}</h6>
                <p class="small text-secondary mb-0">{{ "PhraseDetail" | translate }}</p>
              </div>
            </div>
          </div>
          <!-- Boolean Operators -->
          <div class="col-md-6">
            <div class="guide-item d-flex gap-3">
              <div class="icon-box bg-info-subtle rounded-3 p-2 h-fit">
                <i class="bi bi-diagram-3 text-info fs-4"></i>
              </div>
              <div>
                <h6 class="fw-bold mb-2">{{ "BooleanTitle" | translate }}</h6>
                <p class="small text-secondary mb-0">{{ "BooleanDetail" | translate }}</p>
              </div>
            </div>
          </div>
          <!-- Targeted Searching -->
          <div class="col-md-6">
            <div class="guide-item d-flex gap-3">
              <div class="icon-box bg-warning-subtle rounded-3 p-2 h-fit">
                <i class="bi bi-bullseye text-warning fs-4"></i>
              </div>
              <div>
                <h6 class="fw-bold mb-2">{{ "FieldSearchTitle" | translate }}</h6>
                <p class="small text-secondary mb-0">{{ "FieldSearchDetail" | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 p-4 pt-0">
        <button type="button" class="btn btn-light rounded-pill px-4" data-bs-dismiss="modal">{{ "Close" | translate
          }}</button>
      </div>
    </div>
  </div>
</div>